import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height"],
  _excluded2 = ["renderIcon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { IconContext, DefaultContext } from "./iconContext.js";
export var useSvgProps = function useSvgProps(props) {
  var context = React.useContext(IconContext);
  var contextProps = context || DefaultContext;
  var computedSize = props.size || contextProps.size || '1em';
  var className;
  if (contextProps.className) className = contextProps.className;
  if (props.className) className = (className ? "".concat(className, " ") : '') + props.className;
  var width = props.width,
    height = props.height,
    svgProps = _objectWithoutProperties(props, _excluded);
  if (svgProps.color) {
    delete svgProps.color; // because we convert it into color below so we don't need non svg attr in DOM
  }
  var sizeToUse = {
    width: computedSize,
    height: computedSize
  };
  if (!props.size && (width || height)) {
    sizeToUse = {
      width: width,
      height: height
    };
  }
  return _objectSpread(_objectSpread(_objectSpread({
    strokeWidth: 0,
    fill: 'currentColor'
  }, contextProps.attr), svgProps), {}, {
    className: className,
    style: _objectSpread(_objectSpread({
      color: props.color || contextProps.color
    }, contextProps.style), props.style)
  }, sizeToUse);
};
export function CreateSVG(_ref) {
  var renderIcon = _ref.renderIcon,
    restProps = _objectWithoutProperties(_ref, _excluded2);
  var iconProps = useSvgProps(restProps);
  return renderIcon(iconProps);
}